import { FC, useCallback } from "react";
import { Tooltip } from "@mui/material";
import { EmbeddedTask } from "@/services/cloudchipr.api";
import { useAppDispatch } from "@/store/hooks";
import { useAppAbility } from "@/services/permissions";
import { openDrawerForTaskByIdInResourceGridThunk } from "@/store/task-management/thunks/task-drawer-openers/openDrawerForTaskByIdInResourceGridThunk";
import { TaskStatusCellRenderer } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/TaskStatusCellRenderer";

interface ResourceIdentifierTaskStatusChipProps {
  task: EmbeddedTask | null;
  resourcesMasterGridId: string;
}

export const ResourceIdentifierTaskStatusChip: FC<
  ResourceIdentifierTaskStatusChipProps
> = ({ task, resourcesMasterGridId }) => {
  const dispatch = useAppDispatch();
  const { can } = useAppAbility();
  const canEditTask = can("edit", "task");

  const clickHandler = useCallback(() => {
    if (!task?.id) {
      return;
    }

    dispatch(
      openDrawerForTaskByIdInResourceGridThunk({
        taskId: task.id,
        resourcesMasterGridId,
      }),
    );
  }, [dispatch, resourcesMasterGridId, task?.id]);

  return (
    <Tooltip arrow title={canEditTask ? "Open Task" : ""} placement="top">
      <span>
        <TaskStatusCellRenderer
          task={task}
          onClick={canEditTask ? clickHandler : undefined}
        />
      </span>
    </Tooltip>
  );
};
